import { createIntl, createIntlCache } from "react-intl";
import messages from "./messages";
import LOCALES from "./locales";

const cache = createIntlCache();

export const MESSAGES = {
    [LOCALES.RUSSIAN]: messages[LOCALES.RUSSIAN],
};

export const DEFAULT_LOCALE = LOCALES.RUSSIAN;

export const createCustomIntl = (locale: string = DEFAULT_LOCALE) => {
    return createIntl({ locale, messages: MESSAGES[locale] }, cache);
};

const intl = createCustomIntl(DEFAULT_LOCALE);
export default intl;
